import styles from './FinancialJob.module.scss';

import BackButton from "@src/components/_shared/BackButton";
import Container from "@src/components/_shared/Container";
import BlockTitle from "@src/components/_shared/UI/BlockTitle";
import useRegistrationStore from "@src/stores/registrationStore";
import Subtitle from '@src/components/_shared/UI/Subtitle';
import ValidateChoiceButton from '@src/components/_shared/UI/ValidateChoiceButton';
import { useState } from 'react';
import CompanySearch from '@src/components/_shared/UI/CompanySearch';
import { Form, Formik } from 'formik';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import Input from '@src/components/_shared/UI/Input';
import Loader from '@src/components/_shared/UI/Loader';

type ListedCompanyProps = {
    setListedCompany: React.Dispatch<React.SetStateAction<boolean>>;
    setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>;
    isPending: boolean;
}

export default function ListedCompany({ setListedCompany, setIsSubmit, isPending }: ListedCompanyProps) {
    const { setField, registration } = useRegistrationStore();
    const [searchCompany, setSearchCompany] = useState<boolean>(false);
    const [notFound, setNotFound] = useState<boolean>(false);

    const _onDecline = () => {
        if (registration.person.professional.quoted_company) {
            const { quoted_company, ...professionalWithoutQuotedCompany } = registration.person.professional;
            setField('person.professional', professionalWithoutQuotedCompany);
        }
        setListedCompany(false);
        setIsSubmit(true);
    }

    if (searchCompany) {
        return (
            <Container>
                <BackButton onClick={() => setSearchCompany(false)}/>
                <BlockTitle title="Quelle société cotée ?" />
                <Subtitle content="Indiquez le nom de la société cotée" />
                <Formik
                    initialValues={{
                        company: {
                            name: registration.person.professional.quoted_company && registration.person.professional.quoted_company.name,
                            isin: registration.person.professional.quoted_company?.isin || ''
                        }
                    }}
                    onSubmit={(values) => {
                        setField('person.professional.quoted_company', { name: values.company.name, isin: values.company.isin });
                        setIsSubmit(true);
                    }}
                >
                    {({ handleSubmit, values, setFieldValue }) => {
                        return (
                            <Form id="quotedCompanyForm" autoComplete="off" className="registerForm">
                                <CompanySearch
                                    setNotFound={setNotFound}
                                    selectedCompanyName={registration.person.professional.quoted_company?.name || ''}
                                    setCompany={(value: { name: string, isin: string }) => setFieldValue('company', value)}
                                />
                                {notFound ?
                                    <>
                                        <Input
                                            title="Nom de la société"
                                            name="company_name"
                                            id="company_name"
                                            width="100%"
                                            type="text"
                                            placeholder="Ex : L'Oréal"
                                            value={values.company.name}
                                            onChange={(e) => setFieldValue('company.name', e.target.value)}
                                            clearInput={() => setFieldValue('company.name', '')}
                                        />
                                        <Input
                                            title="Code Isin de la société (facultatif)"
                                            name="company_isin"
                                            id="company_isin"
                                            width="100%"
                                            type="text"
                                            placeholder="Ex : FR0000074254"
                                            value={values.company.isin || ''}
                                            onChange={(e) => setFieldValue('company.isin', e.target.value)}
                                            clearInput={() => setFieldValue('company.isin', '')}
                                        />
                                    </>
                                    : null}
                                <ValidateButton title="Continuer" disabled={!values.company.name} onClick={handleSubmit} onLoading={isPending} />
                            </Form>
                        )
                    }}
                </Formik>
            </Container>
        )
    }

    return (
        <Container>
            <BackButton onClick={() => setListedCompany(false)}/>
            <BlockTitle title="Êtes-vous ou avez-vous été le salarié ou le dirigeant d'une société cotée ou assimilée ?" />
            {isPending ?
                <Loader type="SPINNER" />
                :
                <div className={styles.buttons}>
                    <ValidateChoiceButton title="Oui" selected={registration.person.professional.quoted_company &&registration.person.professional.quoted_company?.name.length > 0} onValidate={() => setSearchCompany(true)} />
                    <ValidateChoiceButton title="Non" selected={registration.person.professional.quoted_company && registration.person.professional.quoted_company.isin === ''} onValidate={_onDecline} />
                </div>
            }
        </Container>
    )
}
